import React, { useState } from "react";
import APIUrls from '../services/APIUrls';
import axiosInstance from '../services/axiosInstance';
import { RotatingLines } from "react-loader-spinner";

export default function SubmitButtonPopup({ setPopUpValue, projectId }) {

    const [loaderState, setLoaderState] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const [showModal, setShowModal] = useState(true)


    const handleCloseModal = () => {
        setPopUpValue(false);
    };

    // Add this function to handle submit confirmation
    const handleSubmitConfirm = async () => {
        try {

            setLoaderState(true);

            const response = await axiosInstance.put(APIUrls.SUBMIT_EDITED_TRANSLATION_UNITS(projectId));
            if (response.status === 200) {
                setLoaderState(false)
                setShowModal(false)
                setSuccessMessage(true)
            }
            else {
                console.error("Unexpected response status:", response.status);
                setLoaderState(false)
            }

            setTimeout(() => {
                setPopUpValue(false)
            }, 3000)

        } catch (err) {
            console.error(err);
            setLoaderState(false)
        }
    };

    function Modal() {
        return (
            <div id="modal-open-10" className='lightbox-panel' aria-labelledby="removelabel" aria-modal="true" role="dialog" >
                <div className="inner-lightbox-panel pb-0">
                    <div className="modal-header flex padd-lr">
                        <h5 id="removelabel">Submit Edits</h5>
                    </div>
                    <div className="lightbox-content padd-22 overflow-icr-approve">
                        <p className="f16-para-icr">
                            {"Do you want to 'Submit' these changes?"}
                        </p>
                        <p className="f16-para-icr" style={{ marginTop: '10px' }}>
                            {"If you proceed, you won't be able to make the changes again as your access will get revoked."}
                        </p>
                    </div>
                    <div className="modal-footer modal-footer-border flex px-22">
                        <button className="btn btn-bold first-focus cancelApprove" onClick={handleCloseModal}>Cancel
                        </button>
                        <button className="btn btn-bold active lastClick submitApprove" onClick={handleSubmitConfirm}>
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    function Loader() {
        return (
            <div className="gb-overlay show">
                <div className="gb-loader">
                    <RotatingLines
                        strokeColor="#0096FF"
                        strokeWidth="5"
                        width="196"
                        visible={true}
                    />
                </div>
            </div>
        )
    }


    function SuccessMessageComponent() {

        return (
            <div className="success-message">
                <span>{"Edited Translation units are successfully synced"}</span>
            </div>
        );
    }


    return (
        <>
            {loaderState ? <Loader /> : showModal && <Modal />}

            {successMessage && <SuccessMessageComponent />}

        </>
    )
}